import React, { useState } from "react";
import { getImidServiceUrl } from "utils/api-util";
import { ClipLoader } from "react-spinners";

const ActivateTenantModal = ({ onClose, addTenantInfo }) => {
  const baseUrl = getImidServiceUrl();

  console.log(addTenantInfo);

  const token = window.localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(false);
  const [msg, setMessage] = useState("");
  const [isSuccessful, setIsSuccessful] = useState(false);

  const data = {
    userId: addTenantInfo?.tenantId,
    customerId: addTenantInfo?.customerId,
    status: "ENABLED",
  };

  const handleSubmit = async (e) => {
    const url = `${baseUrl}/admin/user`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      setIsLoading(true);
      setMessage("");
      const res = await fetch(url, {
        method: "PATCH",
        headers,
        body: JSON.stringify(data),
      });
      const fetchedData = await res.json();
      if (res.ok) {
        console.log(fetchedData);
        setIsSuccessful(true);
      } else {
        setMessage("Error sending Data");
      }
    } catch (err) {
      console.log(err);
      setMessage(err.message);
    } finally {
      setIsLoading(false); // Reset loading to false when login action is completed
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-extrabold mb-4 text-center text-[#4F4F4F]">
          Activate User
        </h2>
        <p className="mb-6 font-semibold text-center text-[#828282]">
          Are you sure you want to Activate this user?
        </p>
        {isLoading ? (
          <div className="flex w-full justify-center">
            <ClipLoader size={20} color="#0074bb" />
          </div>
        ) : (
          <div className="flex justify-center space-x-4">
            <button
              className="px-4 py-2 bg-[#fff] border border-[#0074bb] text-[#0074bb] rounded hover:bg-[#dad5d54e]"
              onClick={onClose}
            >
              No
            </button>

            <button
              className="px-4 py-2 bg-[#0074bb] text-[#fff] rounded hover:bg-[#0054bb]"
              onClick={handleSubmit}
            >
              Yes
            </button>
          </div>
        )}
        <p
          className={`${
            isSuccessful ? "text-green-500" : "text-red-500"
          } text-[10px] my-3 `}
        >
          {msg}
        </p>
      </div>
    </div>
  );
};

export default ActivateTenantModal;
